import { useAuthenticatedMutation } from "@l2r-front/l2r-auth"

export function useCampaignMutation(
    url,
    axiosFn,
    queryParameters,
    config = {},
) {
    const apiUrl = `campaign/${url}`

    return useAuthenticatedMutation(
        apiUrl,
        axiosFn,
        queryParameters,
        config,
    )
}